import { Fragment } from "react";
import "./Web3gameDevelopment.css";
import { web3gameDevelopment } from "../../staticdata";

const Web3gameDevelopment = () => {
  return (
    <Fragment>
      <section className="web3gamedevelopment-style">
        <div className="container">
          <div className="web3gamedevelopment-services">
            <div className="container">
              <div
                className="section-title"
                data-aos="fade-down"
                data-aos-duration="800"
              >
                <h1 className="text-center">
                  <span className="title-gradient">Web3 Game</span> Development
                </h1>
                <p className="text-center">
                  The future gaming age, powered by blockchain technology, will
                  provide gamers with limitless options to acquire real-world
                  assets and generate passive income. Web3 gaming firms are
                  creating metaverse games and giving new chances to users.
                  Align your company with the advanced internet phase
                  characterized by transparency, decentralization, and
                  widespread user acceptance. Contact us to design and construct
                  the finest blockchain-based gaming systems for your specific
                  needs.
                </p>
              </div>
              <div className="row gy-4">
                {web3gameDevelopment.map((services, index) => (
                  <div
                    className="col-md-6 d-flex"
                    key={services.id}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div
                      className="service-item-premium 
                                d-flex flex-column 
                                flex-lg-row flex-md-row 
                                align-items-center 
                                align-items-lg-start 
                                align-items-md-start 
                                gap-3 p-4 w-100"
                    >
                      <div className="icon-ring-premium">
                        <img
                          src={services.icon}
                          alt="img not found"
                          style={{ height: "35px", width: "35px" }}
                        />
                      </div>
                      <div className="service-item-desc">
                        <h5 className="mb-1">{services.title}</h5>
                        <p className="text-light mb-0">
                          {services.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Web3gameDevelopment;
